<template>
  <div class="number-input-mask">
    <div class="input-content">
      <input type="number" min="0" class="number-area" v-model="number" ref="input"  @keydown.enter="saveNumber">
      <div class="row">
        <div class="col-3">
          <div class="bg-number-button" @click="addNumber('1')">1</div>
        </div>
        <div class="col-3">
          <div class="bg-number-button" @click="addNumber('2')">2</div>
        </div>
        <div class="col-3">
          <div class="bg-number-button" @click="addNumber('3')">3</div>
        </div>
        <div class="col-3">
          <div class="bg-number-button" @click="removeNumber">DEL</div>
        </div>
      </div>
      <div class="row" style="margin-top: 0">
        <div class="col-9">
          <div class="row">
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('4')">4</div>
            </div>
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('5')">5</div>
            </div>
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('6')">6</div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('7')">7</div>
            </div>
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('8')">8</div>
            </div>
            <div class="col-4">
              <div class="bg-number-button" @click="addNumber('9')">9</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="bg-number-button bg-number-bottom" @click="addNumber('0')">0</div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="row" style="height: 100%">
            <div class="col-12">
              <div class="bg-number-button bg-number-right" @click="saveNumber">確認</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    defaultNumber: Number,
  },
  data() {
    return {
      number: 0,
      numberString: '0',
    };
  },
  methods: {
    addNumber(val) {
      this.numberString = `${this.numberString}${val}`;
      this.stringToNumber();
    },
    removeNumber() {
      this.numberString = this.numberString.substring(0, this.numberString.length - 1);
      this.stringToNumber();
    },
    stringToNumber() {
      if (this.numberString !== '') {
        this.number = parseInt(this.numberString, 10);
      } else {
        this.number = 0;
      }
    },
    saveNumber() {
      this.$emit('saveNumber', this.number);
    },
  },
  mounted() {
    console.log(this.defaultNumber);
    this.$refs.input.focus();
    if (this.defaultNumber !== undefined) this.number = this.defaultNumber;
  },
  watch: {
    number(val) {
      this.number = parseInt(val, 10);
    },
  },
};
</script>

<style lang="sass" scoped>
.number-input-mask
  position: fixed
  top: 0 
  left: 0
  height: 100vh
  width: 100vw
  z-index: 10
  background: rgba(0,0,0,0.3)
  display: flex
  .input-content
    background: white
    padding: 20px
    margin: auto
    border-radius: 5px
    
.number-area
  background: black
  color: white
  width: 368px
  font-size: 96px


.bg-number-button
  height: 90px
  width: 90px
  background-color: #6f7e95
  display: flex
  justify-content: center
  align-items: center
  color: white
  font-size: 26px
  margin: 1px
  cursor: pointer;
  user-select: none
  &:active
    -moz-box-shadow:    inset 0 0 20px #000000;
    -webkit-box-shadow: inset 0 0 20px #000000;
    box-shadow:         inset 0 0 20px #000000;

.bg-number-bottom
  width: calc(100% - 2px)
  height: 90px

.bg-number-right
  width: 90px
  height: calc(100% - 2px)

.row
  display: flex
  margin: 0px

[class*='col-']
  padding: 0
</style>




// WEBPACK FOOTER //
// NumberInput.vue?3f3760c6